import { Network } from '../types/chains';
import { ChainId } from './enum';

const avaxIcon = '../assets/images/icons/avax.png';
const bscIcon = '../assets/images/icons/bnb.svg';
const optimismIcon = '../assets/images/icons/optimism.svg';
const fantomIcon = '../assets/images/icons/fantom.svg';
const ethIcon = '../assets/images/icons/eth.png';
const polygonIcon = '../assets/images/icons/polygon.png';
const arbitrumIcon = '../assets/images/icons/arbitrum.png';

const infuraKey = process.env.INFURA_API_KEY;

export const NETWORKS: { [key: number]: Network } = {
  [ChainId.ETH]: {
    chainId: ChainId.ETH,
    symbol: 'ETH',
    explorerUrl: 'https://etherscan.io',
    name: 'Ethereum',
    slug: 'ethereum',
    rpcname: 'eth-mainnet',
    coingeckoId: 'ethereum',
    wrappedAddress: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
    imageUrl: ethIcon,
    providerRpcUrl: `https://rpc.ankr.com/eth`,
    testnet: false,
    surrportnet: true,
  },
  [ChainId.Amoy]: {
    chainId: ChainId.Amoy,
    symbol: 'MATIC',
    explorerUrl: 'https://amoy.polygonscan.com',
    name: 'Amoy',
    slug: 'amoy',
    rpcname: 'polygon-amoy',
   // wrappedAddress: '0x9c3c9283d3e44854697cd22d3faa240cfb032889',
    imageUrl: polygonIcon,
    providerRpcUrl: `https://rpc-amoy.polygon.technology`,
    testnet: true,
    surrportnet: true,
  },
  [ChainId.Polygon]: {
    chainId: ChainId.Polygon,
    symbol: 'MATIC',
    explorerUrl: 'https://polygonscan.com',
    name: 'Polygon',
    slug: 'polygon',
    rpcname: 'polygon-mainnet',
    coingeckoId: 'matic-network',
    wrappedAddress: `0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270`,
    providerRpcUrl: `https://polygon-rpc.com/`,
    imageUrl: polygonIcon, 
    testnet: false,
    surrportnet: true,
  }, 
  [ChainId.Optimism]: {
    chainId: ChainId.Optimism,
    symbol: 'OP',
    nativeCurrencyUrl: ethIcon,
    explorerUrl: 'https://optimistic.etherscan.io',
    name: 'Optimism',
    slug: 'optimism',
    rpcname: 'opt-mainnet',
    coingeckoId: 'ethereum',
    wrappedAddress: '0x4200000000000000000000000000000000000006',
    imageUrl: optimismIcon,
    providerRpcUrl: 'https://mainnet.optimism.io',
    nativeCurrency: {
      name: 'Ethereum',
      decimals: 18,
      symbol: 'ETH'
    },
    testnet: false,
    surrportnet: true,
  },
  [ChainId.Arbitrum]: {
    chainId: ChainId.Arbitrum,
    symbol: 'ARB',
    explorerUrl: 'https://arbiscan.io/',
    name: 'Arbitrum',
    slug: 'arbitrum',
    rpcname: 'arb-mainnet',
    coingeckoId: 'ethereum',
    wrappedAddress: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
    nativeCurrencyUrl: ethIcon,
    imageUrl: arbitrumIcon,
    providerRpcUrl: 'https://arb1.arbitrum.io/rpc',
    nativeCurrency: {
      name: 'Ethereum',
      decimals: 18,
      symbol: 'ETH',
    },
    testnet: false,
    surrportnet: true,
  },
  [ChainId.Base]: {
    chainId: ChainId.Base,
    symbol: 'ETH',
    explorerUrl: 'https://basescan.org/',
    name: 'Base',
    slug: 'base',
    rpcname: 'base-mainnet',
    coingeckoId: 'ethereum',
    wrappedAddress: '0x4200000000000000000000000000000000000006',
    nativeCurrencyUrl: ethIcon,
    imageUrl: ethIcon,
    providerRpcUrl: 'https://mainnet.base.org',
    nativeCurrency: {
      name: 'Ethereum',
      decimals: 18,
      symbol: 'ETH',
    },
    testnet: false,
    surrportnet: true,
  },
  [ChainId.Sepolia]: {
    chainId: ChainId.Sepolia,
    symbol: 'ETH',
    explorerUrl: 'https://sepolia.etherscan.io/',
    name: 'Sepolia',
    slug: 'sepolia',
    rpcname: 'eth-sepolia',
    coingeckoId: 'ethereum',
    wrappedAddress: '0x4200000000000000000000000000000000000006',
    nativeCurrencyUrl: ethIcon,
    imageUrl: ethIcon,
    providerRpcUrl: 'https://rpc.sepolia.org',
    nativeCurrency: {
      name: 'Ethereum',
      decimals: 18,
      symbol: 'ETH',
    },
    testnet: true,
    surrportnet: true,
  },
  [ChainId.Arbitrumsepolia]: {
    chainId: ChainId.Arbitrumsepolia,
    symbol: 'ARB',
    explorerUrl: 'https://sepolia-explorer.arbitrum.io/',
    name: 'Arbitrum-Sepolia',
    slug: 'arbitrum-sepolia',
    rpcname: 'arb-sepolia',
    coingeckoId: 'ethereum',
    wrappedAddress: '0xc556bAe1e86B2aE9c22eA5E036b07E55E7596074',
    nativeCurrencyUrl: ethIcon,
    imageUrl: arbitrumIcon,
    providerRpcUrl: 'https://sepolia-rollup.arbitrum.io/rpc',
    nativeCurrency: {
      name: 'Ethereum',
      decimals: 18,
      symbol: 'ETH',
    },
    testnet: true,
    surrportnet: true,
  },
  [ChainId.Basesepolia]: {
    chainId: ChainId.Basesepolia,
    symbol: 'ETH',
    explorerUrl: 'https://sepolia.basescan.org/',
    name: 'Base-Sepolia',
    slug: 'base-sepolia',
    rpcname: 'base-sepolia',
    coingeckoId: 'ethereum',
    wrappedAddress: '0x4200000000000000000000000000000000000006',
    nativeCurrencyUrl: ethIcon,
    imageUrl: ethIcon,
    providerRpcUrl: 'https://base-sepolia.blockpi.network/v1/rpc/public',
    nativeCurrency: {
      name: 'Ethereum',
      decimals: 18,
      symbol: 'ETH',
    },
    testnet: true,
    surrportnet: true,
  }, 
  [ChainId.Optimismsepolia]: {
    chainId: ChainId.Optimismsepolia,
    symbol: 'OP',
    explorerUrl: 'https://sepolia-optimism.etherscan.io/',
    name: 'Optimism-Sepolia',
    slug: 'Optimism-sepolia',
    rpcname: 'opt-sepolia',
    coingeckoId: 'ethereum',
    wrappedAddress: '0x4200000000000000000000000000000000000006',
    nativeCurrencyUrl: ethIcon,
    imageUrl: optimismIcon,
    providerRpcUrl: 'https://sepolia.optimism.io',
    nativeCurrency: {
      name: 'Ethereum',
      decimals: 18,
      symbol: 'ETH',
    },
    testnet: true,
    surrportnet: true,
  },
};
